import { supabase } from '@/integrations/supabase/client';

export interface WaitlistRegistration {
  email: string;
  full_name?: string;
  role?: string;
  company_type?: string;
  company_stage?: string;
  analysis_purpose?: string;
}

export const waitlistService = {
  async register(data: WaitlistRegistration): Promise<void> {
    const { error } = await supabase
      .from('waitlist')
      .insert({
        email: data.email,
        full_name: data.full_name,
        role: data.role,
        company_type: data.company_type,
        company_stage: data.company_stage,
        analysis_purpose: data.analysis_purpose,
      });
    if (error) throw error;
  },
};
